<template>
  <v-autocomplete
    v-model="VALOR_MODEL_COMPUTED"
    outlined
    :items="itens"
    :error-messages="mensagem"
    v-bind="$attrs"
  />
</template>

<script>
export default {
  model: {
    prop: "modelValue",
    event: "update:modelValue"
  }
}
</script>

<script setup>
import {computed, onMounted, ref} from "vue";
import api from "@/api/api";

const props = defineProps({
  modelValue: [Array, String, Number],
  idpedido_systock: {
    type: Number,
    requied: true,
  },
  entidade: String,
});

const emit = defineEmits(['update:modelValue']);

const VALOR_MODEL_COMPUTED = computed({
  get: () => props.modelValue,
  set: valor => emit('update:modelValue', valor),
});

const itens = ref([]);
const mensagem = ref('');

onMounted(getItens);

function getItens() {
  mensagem.value = '';

  api.get(`pedidos-drp/${props.idpedido_systock}/exportacao/nativa-winthor/filtros/${props.entidade}`)
    .then(response => {
      if (response.data.valor_padrao) {
        VALOR_MODEL_COMPUTED.value = response.data.valor_padrao;
      }

      itens.value = response.data[props.entidade.replace(/-/, '_')].map(item => ({
        value: item.codigo,
        text: `${item.codigo} - ${item.nome}`,
      }));
    })
    .catch(() => mensagem.value = 'Erro ao buscar lista de registros')
}
</script>
